import { jsx as o } from "react/jsx-runtime";
import "./components/CustomLayout.js";
import c from "./components/DatePickerItem.js";
import l from "./components/DateTimePicker.js";
import "./components/SpecificTextField.js";
import d from "./components/TimePicker.js";
const f = (a) => {
  const { type: m = "date", variant: e = "dynamic", slotProps: t = void 0, required: s = !1, tooltip: p = !1, ...r } = a, i = {
    ...t,
    // @ts-expect-error - TODO: Fix component typing.
    textField: {
      ...t == null ? void 0 : t.textField,
      required: s,
      tooltip: p
    }
  };
  return m === "time" ? /* @__PURE__ */ o(d, {
    variant: e,
    slotProps: i,
    ...r
  }) : m === "timeDate" ? /* @__PURE__ */ o(l, {
    variant: e,
    slotProps: i,
    ...r
  }) : /* @__PURE__ */ o(c, {
    variant: e,
    slotProps: i,
    ...r
  });
};
f.displayName = "DatePicker";
export {
  f as default
};
